/**
 * Запасные шрифты для письменностей, которых нет в Playpen Sans.
 *
 * Без них браузер сам выбирает системный шрифт с грузинским или хангылем —
 * у каждого пользователя свой, заметно шире расчётного, — и текст вылезает за
 * плашку. Ширины этих шрифтов заложены в перенос строк: см. `textWidthChars`
 * в `@kitup/book-schema`. PDF-рендерер встраивает те же Noto под именем
 * «Playpen Sans», поэтому лишние имена в стеке ему не мешают.
 */
export const BOOK_FALLBACK_FONTS = ['Noto Sans Georgian', 'Noto Sans KR'];
/** CSS-значение `font-family`: шрифт книги, запасные Noto, затем `sans-serif`. */
export function bookFontStack(fontFamily = 'Playpen Sans') {
    const families = [fontFamily, ...BOOK_FALLBACK_FONTS].filter((family, index, all) => all.indexOf(family) === index);
    return [...families.map((family) => `'${family.replaceAll("'", "\\'")}'`), 'sans-serif'].join(', ');
}
//# sourceMappingURL=font-stack.js.map